import { css } from "@emotion/react";
import { rem } from "@util/convertUnits";
import Header from "@/base/Header";
import Kicker from "@/base/Kicker";
import Text from "@/base/Text";
import GenericPageBanner from "@/core/common/GenericPageBanner";

import BecomeDealerForm from "./components/BecomeDealerForm";
import FormPrivacyPolicy from './components/FormPrivacyPolicy';
import HelmetBuilder from "@/base/HelmetBuilder";

const BecomeDealerFormPage = () => {

  const containerCss = css(`
    width: 100%;
    max-width: ${rem(800)};
    margin-left: auto;
    margin-right: auto;
  `);

  const formCss = css(`
    width: 100%;
    max-width: ${rem(520)};
    margin-left: auto;
    margin-right: auto;
  `);

  const buildMeta = () => {

    let data = {
      title: `Request a Quote | LaCantina Doors`,
      description: `Request a Quote`,
      keywords: 'BiFold Doors, Accordion, Folding Glass, Multi Slide, Swing Doors & Windows!',
    }

    return <HelmetBuilder data={data} preview={false} />
  }

  return (
    <div>
      {buildMeta()}
      <GenericPageBanner image="/images/banners/generic.jpg" localImage={true}>
        <Kicker stylesOverride={{ textShadow: "0 0 1rem rgb(255,255,255)" }}>Professionals</Kicker>
        <Header tag="h1" style={{ textShadow: "0 0 1.5rem rgba(255,255,255,0.8)" }}>Become a Dealer</Header>
      </GenericPageBanner>

      <div className="container m-gap">
        <div css={containerCss}>
          <Text>
            The demand for LaCantina Doors is growing rapidly and we are
            interested in expanding our dealer base. LaCantina Doors is looking
            for experienced window and door sales organizations to represent our
            product.
          </Text>
          <Text>
            If you are interested in becoming a LaCantina Doors Dealer or would
            like additional information, please fill out the following form.
          </Text>
        </div>

        <div className="mb-5" css={formCss}>
          <BecomeDealerForm />
          <FormPrivacyPolicy />
        </div>

      </div>
    </div>
  );
};

export default BecomeDealerFormPage;
